// src/components/Navbar.js
import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import { Offcanvas, Button, Collapse } from 'react-bootstrap';
import Tema from '../../context/Tema';
import MenuComponente from './MenuComponente';
import { useProvider, isNative } from '../../context/MenuProvider'; // Importa o contexto do Menu
import './Navbar.css';

const  Navbar = () => {
  const { 
    setLinks, 
    setBtns,
    crud,
    site,
    auth,
    hasPerms,
    title,
    setTitle,
    handleEnviarWhats,
  } = useProvider(); // Acessa a função setLinks para atualizar os links do menu
  const [isOpen, setIsOpen] = useState(false);
  const [openCollapse, setOpenCollapse] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();
  const { id, tipo } = useParams();
  const { get, loading, error } = crud || {};
  const [loja, setLoja] = useState(auth?.empresa);
  
  const queryParams = new URLSearchParams(location.search);
  
  
  // Rotas com botão de voltar
  const backButtonRoutes = [
    "/",
    "/painel"
  ];
  
  const normalize = path => path.replace(/\/+$/, ""); // remove barras finais
  
  const showBackButton = !backButtonRoutes.some(route => normalize(location.pathname) === normalize(route));
  
  useEffect(() => {
    if(!showBackButton) navigate({ replace: true }); // Navegação inicial
    return () => {setTitle(``);}
  }, [showBackButton]);
    
  const toggleMenu = () => setIsOpen(!isOpen);
  const handleBack = () => navigate(-1);

  // Define os links iniciais para o MenuComponente
  useEffect(() => {
    setLinks([
      //{ name: 'Perfil', to: '/painel/' },
      //{ name: 'Configurações', to: '/configuracoes' },
    ]);
    setBtns([
      //{ name: 'Perfil', to: '/painel/' },
      //{ name: 'Configurações', to: '/configuracoes' },
    ]);
    return () => {setLinks([]); setBtns([]);}
  }, [setLinks, setBtns]);

  const menuItems = [
    {
      label: 'Página Inicial',
      icon: 'bi bi-house',
      to: `/painel`,
      onClick: null,
      perms: null,
      links: null,
    },
    {
      label: 'Gestão de Vendas',
      icon: 'bx bx-shopping-bag',
      to: null,
      onClick: null,
      perms: ["loja.view_produtos", "loja.view_marca", "loja.view_venda", "loja.view_clientes"],
      links: [
        { label: 'Meus Clientes', icon: null, to: '/clientes', onClick: null, perms: ['loja.view_clientes'], links: null },
        { label: 'Minhas Vendas', icon: null, to: '/vendas', onClick: null, perms: ['loja.view_venda'], links: null },
        { label: 'Meus Recebimentos', icon: null, to: '/pagamentos?receita=true', onClick: null, perms: ['loja.view_pagamentos'], links: null },
        { label: 'Meu Estoque', icon: null, to: '/produtos', onClick: null, perms: ['loja.view_produtos'], links: null },
        { label: 'Atualizar Estoque', icon: null, to: '/produtos/atualizar-quantidade', onClick: null, perms: ['loja.view_produtos'], links: null },
        { label: 'Minhas Marcas', icon: null, to: '/marcas', onClick: null, perms: ['loja.view_marca'], links: null },
      ],
    },
    {
      label: 'Gestão de Rede',
      icon: 'bx bx-sitemap',
      to: null,
      onClick: null,
      perms: ['rede.view_prospecto','rede.view_apn','rede.view_consultor'],
      links: [
        { label: 'Prospectos', icon: null, to: '/rede/prospecto', onClick: null, perms: ['rede.view_prospecto'], links: null },
        { label: "APN's (Apresentação)", icon: null, to: '/rede/apn', onClick: null, perms: ['rede.view_apn'], links: null },
        { label: 'Minha Equipe', icon: null, to: '/rede/consultor', onClick: null, perms: ['rede.view_consultor'], links: null },
      ],
    },
    {
      label: 'Apresentação Slide',
      icon: 'bx bx-slideshow',
      to: null,
      onClick: null,
      perms: ["rede.view_apresentacao", "rede.add_apresentacao0"],
      links: [
        { label: 'Minhas Apresentações', icon: null, to: '/painel/apresentacoes', onClick: null, perms: ['rede.view_apresentacao'], links: null },
        { label: 'Nova', icon: null, to: '/painel/slide', onClick: null, perms: ['rede.add_apresentacao'], links: null },
      ],
    },
    {
      label: 'Gestão Financeira',
      icon: 'bx bx-dollar',
      to: null,
      onClick: null,
      perms: ['financas.view_financeiro','financas.add_financeiro'],
      links: [
        { label: 'Minhas Despesas', icon: null, to: '/pagamentos/despesas/pessoais', onClick: null, perms: ['financas.view_financeiro'], links: null },
        { label: 'Custos do Negócio', icon: null, to: 'pagamentos/despesas/negocio', onClick: null, perms: ['financas.view_financeiro'], links: null },
        { label: 'Fluxo de caixa', icon: null, to: '/pagamentos/fluxo-de-caixa', onClick: null, perms: ['financas.view_financeiro'], links: null },
        { label: 'Nova Despesa', icon: null, to: '/despesas/novo/pessoais,negocio', onClick: null, perms: ['financas.add_financeiro'], links: null },
        { label: 'Nova Despesa Pessoal', icon: null, to: '/despesas/novo/pessoais', onClick: null, perms: ['financas.add_financeiro'], links: null },
        { label: 'Novo Custo do Negócio', icon: null, to: '/despesas/novo/negocio', onClick: null, perms: ['financas.add_financeiro'], links: null },
      ],
    },
    {
      label: 'Categorias',
      icon: 'bx bx-network-chart',
      to: null,
      onClick: null,
      perms: ['loja.view_categoria','loja.add_categoria'],
      links: [
        { label: 'Todas as Categorias', icon: null, to: '/categorias/', onClick: null, perms: null, links: null },
        { label: 'Nova Categoria de Produtos', icon: null, to: '/categorias/novo/produtos', onClick: null, perms: ['loja.view_produtos'], links: null },
        { label: 'Novo tipo de cobrança', icon: null, to: '/categorias/novo/cobranca', onClick: null, perms: ['loja.view_cobranca'], links: null },
        { label: 'Nova Tag', icon: null, to: '/categorias/novo/tags', onClick: null, perms: ['core.view_contato'], links: null },
        { label: 'Nova Categoria de Rede', icon: null, to: '/categorias/novo/rede', onClick: null, perms: ['rede.view_apn'], links: null },
        { label: 'Nova Categoria de Despesas Pessoais', icon: null, to: '/categorias/novo/pessoais', onClick: null, perms: ['financas.view_financeiro'], links: null },
        { label: 'Nova Categoria de Custos do Negócio', icon: null, to: '/categorias/novo/negocio', onClick: null, perms: ['financas.view_financeiro'], links: null },
      ],
    },
    {
      label: 'Agenda',
      icon: 'bx bx-calendar',
      to: null,
      onClick: null,
      perms: ['loja.view_agenda','loja.add_agenda'],
      links: [
        { label: 'Minha Agenda', icon: null, to: '/agenda', onClick: null, perms: ['loja.view_agenda'], links: null },
        { label: 'Novo Compromisso', icon: null, to: '/agenda/nova', onClick: null, perms: ['loja.add_agenda'], links: null },
      ],
    },
    {
      label: 'Mensagens para WhatsaApp',
      icon: 'bx bx-chat',
      to: "/mensagens",
      onClick: null,
      perms: ['core.view_whatsappmensagem'],
      links: null,
    },
    {
      label: 'Relatórios',
      icon: 'bi bi-file-text',
      to: null,
      onClick: null,
      perms: ['loja.view_metamensal'],
      links: [
        { label: 'Gestão de Vendas', icon: null, to: '/painel/gestao/vendas', onClick: null, perms: ["loja.view_produtos", "loja.view_marca", "loja.view_venda", "loja.view_clientes"], links: null },
        { label: 'Gestão de Rede', icon: null, to: '/painel/gestao/rede', onClick: null, perms: ['rede.view_prospecto','rede.view_apn','rede.view_consultor'], links: null },
        { label: 'Gestão Financeira', icon: null, to: '/painel/gestao/financas', onClick: null, perms: ['financas.view_financeiro'], links: null },
      ],
    },
    {
      label: 'Loja Virtual',
      icon: 'bi bi-shop',
      to: null,
      onClick: null,
      perms: ['loja.view_produtos'],
      links: [
        { label: 'Ver loja virtual', icon: null, to: `/catalogo/${!site?.empresa ? `${loja?.url}/`:''}`, onClick: null, perms: null, links: null },
        { label: 'Divulgar link da loja', icon: null, to: null, onClick: () => divulgarLoja(), perms: null, links: null },
      ],
    },
    {
      label: 'Divulgar Catálogo',
      icon: 'bi bi-share-fill',
      to: null,
      onClick: () => divulgarLoja(),
      perms: [`loja.view_produtos`],
      links: null,
    },
    {
      label: 'Divulgar App',
      icon: 'bi bi-share',
      to: null,
      onClick: () => divulgarApp(),
      perms: null,
      links: null,
    },
    {
      label: 'Configurações',
      icon: 'bi bi-gear-fill',
      to: null,
      onClick: null,
      perms: null,
      links: [
          { label: 'Todas configurações', icon: null, to: '/config', onClick: null, perms: null, links: null },
          { to: "/config/funcoes", icon: "bx bx-slider", label: "Ativar/Desativar Funções", info: "Selecionar funções do App que deseja usar", perm: null },
          { to: "/config/atalhos", icon: "bx bx-dialpad-alt", label: "Acesso Rápido", info: "Configurar atalhos para acesso rápido das funções desejadas", perm:null },
          { to: "/config/push", icon: "bx bx-bell", label: "Notificações", info: "Configure as notificações que deseja receber", perm: ['core.view_pushmensagem'] },
          { to: "/integracao/whatsapp", icon: "bx bxl-whatsapp", label: "WhatsApp", info: "Conectar WhatsApp para envio de mensagens automático", perm: ['core.view_whatsappmensagem'] },
          //{ to: "/config", icon: "bx bx-calculator", label: "Juros e multa", info: "Configurar as taxas de juros e multas por atraso", perm: ['loja.view_juros'] },
          //{ to: "/config", icon: "bx bx-cycling", label: "Taxas de entrega", info: "Configurar taxas de entrega", perm: ['loja.view_entrega'] },
          { to: "/config/cobrancas", icon: "bx bx-message-dots", label: "Templates de Cobranças", info: "Templates de mensagens para cobranças", perm: ['loja.view_cobranca'] },
          { to: "/integracao", icon: "bx bx-check-shield", label: "Conta Bancária", info: "Vincular conta bancária para receber pagamentos", perm: ['pagamento_online.view_configurarpagamento'] },
          { to: "/produtos/convite", icon: "bx bx-transfer-alt", label: "Sincronizar Estoque (A/B)", info: "Sincronizar escoque com outra conta do app", perm: ['loja.view_convitemesclagemestoque'] },
          { to: "/produtos/parceiros", icon: "bx bx-box", label: "Catálogos de Parceiros", info: "Carregar estoque com produtos já cadastrados por parceiros", perm: ['loja.view_produtos'] },
          { to: "/painel/site", icon: "bx bx-globe", label: "Configurar App", info: "Configurar App do seu negócio", perm: ['loja.view_customsite'] },
          
          { to: "/config/backup", icon: "bx bx-data", label: "Backup automático", info: "Configurar o período backup de segurança dos dados e receba no email", perm: null },
          { to: "/painel/perfil", icon: "bx bx-user", label: "Perfil de Cadastro", info: "Editar perfil de cadastro", perm: null },
        // { label: 'Todas configurações', icon: null, to: '/config', onClick: null, perms: null, links: null },
        // { label: 'Configurar Funções', icon: null, to: '/config/funcoes', onClick: null, perms: null, links: null },
        // { label: 'Juros e multa', icon: null, to: '/config/juros', onClick: null, perms: ['loja.view_juros'], links: null },
        // { label: 'Taxas de entrega', icon: null, to: '/config/entregas', onClick: null, perms: ['loja.view_entrega'], links: null },
        // { label: 'Configurar Cobranças', icon: null, to: '/config/cobrancas', onClick: null, perms: ['loja.view_cobranca'], links: null },
        // { label: 'Conectar Banco', icon: null, to: '/config/online', onClick: null, perms: ['pagamento_online.view_configurarpagamento'], links: null },
        // { label: 'Conectar WhatsaApp', icon: null, to: '/config/online', onClick: null, perms: ['pagamento_online.view_configurarpagamento'], links: null },
        // { label: 'Sincronizar Estoque (A/B)', icon: null, to: '/config/convite-estoque', onClick: null, perms: ['loja.view_convitemesclagemestoque'], links: null },
        // { label: 'Catálogos de parceiros', icon: null, to: '/config/catalogos', onClick: null, perms: ['loja.view_produtos'], links: null },
        // { label: 'Configurar App', icon: null, to: '/config/site', onClick: null, perms: ['loja.view_customsite'], links: null },
        // { label: 'Perfil de Cadastro', icon: null, to: '/config/perfil', onClick: null, perms: null, links: null },
      ],
    },
    {
      label: 'Dispositivos',
      icon: 'bi bi-person-workspace',
      to: '/painel/dispositivos',
      onClick: null,
      perms: null,
      links: null,
    },
    {
      label: 'Suporte',
      icon: 'bi bi-life-preserver',
      to: null,
      onClick: null,
      perms: null,
      links: [
        { label: 'GVendas IA', icon: null, to: '/painel/chat', onClick: null, perms: null, links: null },
        { label: 'WhatsAp (11) 96617-5193', icon: null, to: null, onClick: () => suporteWhatsApp(), perms: null, links: null },
      ],
    },
    {
      label: 'Sair',
      icon: 'bi bi-box-arrow-right',
      to: "/logout",
      onClick: null,
      perms: null,
      links: null,
    },
  ];
  
  const filteredItems = menuItems
  .filter(item => !item.perms || hasPerms(item.perms)) // filtra os itens principais
  .map(item => {
    if (!!item.links) {
      return {
        ...item,
        links: (item.links??[]).filter(link => !link.perms || hasPerms(link.perms)) // filtra os links
      };
    }
    return item;
  });
  
  
  const getTitles = (items) => {
    return items.reduce((acc, item) => {
      if (item.to) acc[item.to] = item.label;
  
      // verifica links ou lista interna
      const children = item.links || item.lista;
      if (Array.isArray(children)) {
        children.forEach(sub => {
          if (sub.to) acc[sub.to] = sub.label;
        });
      }
  
      return acc;
    }, {});
  };
  
  const titles = getTitles(filteredItems);

  const pageTitle = titles[location.pathname];
  
  const suporteWhatsApp = async() => {
    const texto = "Olá Francisco\nEstou com uma dúvida/dificuldade ao usar o App de Gestão.\nAssim que possível, entra em contato comigo :)";
    //const mensagem = encodeURIComponent(texto);
    await handleEnviarWhats('11966175193', texto);
    //const url = `whatsapp://send?phone=+5511966175193&text=${mensagem}`;
    //window.open(url);
  }

  const divulgarLoja = async () => {
      const randomNumber = Math.floor(Math.random() * (9999 - 1000 + 1)) + 1000;
      let texto = `Olá, tudo bom?\n\nMeu catálogo está no app ${site.nome_curto}\n\nAproveiteve já faça seu pedido...\nDisponível em\nhttps://${site?.domain}/catalogo/${loja?.url}/`;
      if (!!site?.empresa) {
          texto = `Olá, tudo bom?\nEssa é o meu App ${site.nome_curto}, aproveite e já faça seu pedido.\n\n${site?.descricao}\nDisponível em\nhttps://${site.domain}`;
      }
      await handleEnviarWhats(null, texto)
  
      //const mensagem = encodeURIComponent(texto);
      //const url = `whatsapp://send?text=${mensagem}`;
      //window.open(url);
  };
  const divulgarApp = async() => {
    const texto = `Olá tudo bom.\nEu uso esse App que me ajuda no controle das minhas vendas, você também vai gostar...\n\nhttps://${site?.domain}/instalar-app/${loja?.url}/`;
    //const mensagem = encodeURIComponent(texto);
    //const url = `whatsapp://send?text=${mensagem}`;
    //window.open(url);
    await handleEnviarWhats(null, texto)
  }

  const handleCollapseToggle = (index) => {
    setOpenCollapse(openCollapse === index ? null : index);
  };
  
  const btn = {
    onClick:toggleMenu,
    className:"text-start w-100 btn",
  }

  return (
    <>
      <div
        className="navbar navbar-light py-2 fixed-top shadow"
        style={{
          borderBottom: loading
            ? '3px solid orange'
            : error
            ? error?.name === 'CanceledError'
              ? ''
              : '3px solid red'
            : ''
        }}
      >
        <div className="container fs-5 d-flex align-items-center">
          
          {/* Botão voltar / menu */}
          {(showBackButton && location.key !== 'default') ? (
            <Button id="menuPrincipal" variant="transparent" onClick={handleBack} className="me-3">
              &larr;
            </Button>
          ) : (
            <Button id="menuPrincipal" variant="transparent" onClick={toggleMenu} className="me-3">
              &#9776;
            </Button>
          )}
      
          {/* Texto que deve cortar */}
          <div
            style={{
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              flex: 1 // ocupa o espaço restante
            }}
          >
            {pageTitle || title || site?.name}
          </div>
      
          {/* Menu */}
          <MenuComponente />
        </div>
      </div>
      <Offcanvas show={isOpen} onHide={toggleMenu} placement="start" className="navbar-light">
        <Offcanvas.Header closeButton closeVariant="transparent">
          <Offcanvas.Title>{site?.nome_curto}</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          {/* Itens do menu dinâmico com collapse */}
          {filteredItems.map((item, index) => (
            <div key={`filtered_itens_${index}`}>
              <Link
                variant="btn"
                to={item.to || ``}
                onClick={() => {if(item.to) toggleMenu(); if(!item.to) handleCollapseToggle(index); if(item.onClick) item.onClick();}}
                className="w-100 text-start btn text-decoration-none"
              >
                {item.icon && (<><i className={item.icon}></i>{` `}</>)}{item.label}
              </Link>
              {item.links && (<>
                <Collapse in={openCollapse === index}>
                  <div>
                    <ul className="list-unstyled">
                      {item.links.map((link, idx) => (
                        <li key={`filtered_itens_${index}_${idx}`}>
                          <Link to={link.to || ``} className="text-start w-100 btn ms-3" onClick={()=>{toggleMenu(); if(link.onClick) link.onClick();}}>
                            {link.icon && (<><i className={link.icon}></i>{` `}</>)}{link.label}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  </div>
                </Collapse>
              </>)}
            </div>
          ))}
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
}

export default Navbar;